<template>
  <div v-if="show">
    <!-- Off-canvas menu background overlay -->
    <transition
      enter-class="opacity-0"
      enter-active-class="ease-out transition-medium"
      enter-to-class="opacity-100"
      leave-class="opacity-100"
      leave-active-class="ease-out transition-medium"
      leave-to-class="opacity-0"
      appear
    >
      <div v-show="show" class="z-10 fixed inset-0 transition-opacity">
        <div
          @click="$store.commit('setShowMenu', false);"
          class="absolute inset-0 bg-black opacity-50"
          tabindex="-1"
        ></div>
      </div>
    </transition>

    <!-- Off-canvas menu -->
    <transition
      enter-class="translate-x-full"
      enter-active-class="ease-out transition-slow"
      enter-to-class="translate-x-0"
      leave-class="translate-x-0"
      leave-active-class="ease-in transition-medium"
      leave-to-class="translate-x-full"
      appear
    >
      <div
        v-show="show"
        class="z-10 fixed inset-y-0 left-0 max-w-xs w-full bg-light-orange text-white transition-transform overflow-y-auto flex flex-col justify-between"
      >
        <div class="relative z-10 pt-navbar">
          <div
            :class="show ? 'block' : 'hidden'"
            class="relative top-0 left-0 p-4"
          >
            <button
              @click="$store.commit('setShowMenu', false);"
              ref="closeButton"
              type="button"
              class="focus:outline-none focus:text-gray-900"
              aria-label="Close"
            >
              <svg class="h-6 w-6" fill="currentColor" viewBox="0 0 24 24">
                <path
                  d="M18.2929 19.7071C18.6834 20.0976 19.3166 20.0976 19.7071 19.7071C20.0976 19.3166 20.0976 18.6834 19.7071 18.2929L13.4142 12L19.7071 5.70711C20.0976 5.31658 20.0976 4.68342 19.7071 4.29289C19.3166 3.90237 18.6834 3.90237 18.2929 4.29289L12 10.5858L5.70711 4.29289C5.31658 3.90237 4.68342 3.90237 4.29289 4.29289C3.90237 4.68342 3.90237 5.31658 4.29289 5.70711L10.5858 12L4.29289 18.2929C3.90237 18.6834 3.90237 19.3166 4.29289 19.7071C4.68342 20.0976 5.31658 20.0976 5.70711 19.7071L12 13.4142L18.2929 19.7071Z"
                />
              </svg>
            </button>
          </div>
          <div class="px-4 pb-6">
            <slot />
          </div>
        </div>
        <div class="relative">
          <div class="p-4">
            <slot name="bottom" />
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'SlideNavigation',
  computed: {
    show () {
      return this.$store.state.showMenu
    }
  }
}
</script>

<style scoped>

</style>
